import styled from 'styled-components'
import { Row } from 'react-bootstrap'

const PageHeader = styled(Row)`
  padding: 14px 20px 10px 0;
`

export default PageHeader
